import Patient from '../../services/patient.service'
import { operationInProgress, updateUser } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import { message } from 'antd'
import { constants } from '../../constants'

/*
Actions to be dispatched for signin
- patientList
    Get patient information for given company
- service error
*/
export function serviceError(bool, message) {
  return {
    type: ActionType.SERVICE_ERROR,
    hasError: bool,
    message,
  }
}

export function fetchInProgress(bool) {
  return {
    type: ActionType.PATIENT_INPROGRESS,
    isLoading: bool,
  }
}

export function setPatient(patient) {
  return {
    type: ActionType.SET_PATIENT,
    patient,
  }
}
// TracPatch Progress-Test (active ROM) records for the currently-open patient.
// Stored in redux so the Activity Calendar and Day View can treat a TracPatch
// measurement as "done" on days the patient completed a Progress Test, even
// though those tests live outside the device timesheet.
export function setPatientRom(roms) {
  return {
    type: ActionType.SET_PATIENT_ROM,
    roms,
  }
}

// Fetch just the ROM/Progress-Test records for a patient and stash them in
// redux. Lighter than getTracPatchData (no steps/temperature) — used by the
// patient-detail page which only needs ROM completion for the calendar.
export function getPatientRomTests(id) {
  return async (dispatch) => {
    try {
      let rom = await serviceInterface.PatientService().getTracPatchROM(id)
      dispatch(setPatientRom((rom && rom.data) || []))
    } catch (err) {
      console.log(err)
      dispatch(setPatientRom([]))
    }
  }
}

export function setActiveAssignedDevices(activeDevices) {
  return {
    type: ActionType.SET_ACTIVE_DEVICES,
    activeDevices,
  }
}

export function patientList(data, params, selectedPatients) {
  return {
    type: ActionType.PATIENT_LIST,
    patients: data.patients,
    metadata: data.metadata,
    filters: params.filters,
    sorter: params.sorter,
    selectedPatients,
  }
}

// Client-side quick-search term for the patient list. The table filters the
// already-loaded list in memory, so this is just shared UI state.
export function setPatientSearch(search) {
  return {
    type: ActionType.SET_PATIENT_SEARCH,
    search,
  }
}

// Client-side schedule view for the active patient list: 'scheduled'
// (surgery date < 6 months out), 'unscheduled' (surgery date >= 6 months out),
// or 'all'. The table filters the already-loaded list in memory, so this is
// just shared UI state. Only meaningful for active patients.
export function setPatientScheduleView(scheduleView) {
  return {
    type: ActionType.SET_PATIENT_SCHEDULE_VIEW,
    scheduleView,
  }
}

export function companyPatientList(data, params, selectedPatients) {
  return {
    type: ActionType.COMPANY_PATIENT_LIST,
    patients: data.patients,
    filters: params.filters,
    metadata: data.metadata,
  }
}

export function notification(notifyError, notifyMessage) {
  return {
    type: ActionType.NOTIFY,
    notifyError,
    notifyMessage,
  }
}

export function mail(mailError, mailMessage) {
  return {
    type: ActionType.MAIL,
    mailError,
    mailMessage,
  }
}

export function rowSelect(selectedPatients) {
  return {
    type: ActionType.ROW_SELECT,
    selectedPatients,
  }
}

export function statistics(stats) {
  return {
    type: ActionType.STATS,
    stats,
  }
}

export function lastActivities(activity) {
  return {
    type: ActionType.SET_ACTIVITIES,
    activity,
  }
}

export function lastMeasurements(measurement) {
  return {
    type: ActionType.SET_MEASUREMENTS,
    measurement,
  }
}
export function setNewPatient(newpatient) {
  return {
    type: ActionType.SET_NEW_PATIENT,
    newpatient,
  }
}

export function setPatNotifications(notifications) {
  return {
    type: ActionType.SET_PAT_NT,
    notifications,
  }
}
export function setPatActivityLog(activitylogs) {
  return {
    type: ActionType.SET_PAT_ACTIVITYLOG,
    activitylogs,
  }
}
export function setActionDisabled(isActive) {
  return {
    type: ActionType.SET_PAT_ISACTIVE,
    isActive,
  }
}

export function setDefaultFilter(filter) {
  console.log('ESQW', filter)
  return {
    type: ActionType.SET_DEFAULT_FILTER,
    filter,
  }
}

// `silent` skips the global loading flag so a background refresh (e.g. the
// login-status poll) updates the list without flashing the table spinner.
export function getPatientList(params, selectedPatients, silent = false) {
  return async (dispatch) => {
    try {
      console.log(params, selectedPatients, 'getting patients')
      if (!silent) dispatch(fetchInProgress(true))
      var data = await serviceInterface.PatientService().getPatientList(params)
      if (params.filters.remember) dispatch(setDefaultFilter(params.filters))
      if (!silent) dispatch(fetchInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(patientList(data, params, selectedPatients))
    } catch (err) {
      console.log(err)
      if (!silent) dispatch(fetchInProgress(false))
      if (!silent) dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getPatientListForCompany(params, selectedPatients) {
  return async (dispatch) => {
    try {
      console.log(params, selectedPatients, 'getting patients')
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .PatientService()
        .getPatientListForCompany(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
        return false
      } else {
        dispatch(companyPatientList(data, params, selectedPatients))
        return true
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getRegisteredPatients(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .PatientService()
        .getRegisteredPatients(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
        return false
      } else {
        dispatch(companyPatientList(data, params))
        return true
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function deleteRegisteredPatient(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .PatientService()
        .deleteRegisteredPatient(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        dispatch(serviceError(true, data.message))
        return false
      } else {
        dispatch(companyPatientList(data, params))

        message.success('Patient deleted successfully')
        return true
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function sendNotification(params) {
  return async (dispatch) => {
    try {
      // console.log('getting patients');
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .PatientService()
        .sendNotifications(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        dispatch(notification(true, data.message))
        return false
      } else {
        dispatch(notification(false, 'Message Sent!'))
        return true
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
      return false
    }
  }
}
export function caregiverNotify(caregiver) {
  return async (dispatch) => {
    try {
      // console.log('getting patients');
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .PatientService()
        .caregiverNotify(caregiver)
      dispatch(fetchInProgress(false))
      if (data.status == constants.MESSAGE.SUCCESS) {
        message.success(data.message)
        return data
      } else {
        message.error(data.message)
        return data
        // dispatch(mail(false, "success")); return true;
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
      return false
    }
  }
}
export function sendMail(params, user) {
  return async (dispatch) => {
    try {
      // console.log('getting patients');
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.PatientService().sendMail(params)
      dispatch(fetchInProgress(false))
      if (data.error) {
        dispatch(mail(true, 'fail'))
        message.info(data.message)
        return false
      } else {
        dispatch(mail(false, 'success'))
        return true
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
      return false
    }
  }
}

export function getReport(id, newTab) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      await serviceInterface.PatientService().downloadReport(id, newTab)
      dispatch(fetchInProgress(false))
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getStats(customerid) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .getPatientStats(customerid)
      console.log('getStats action received data:', data)
      if (data.error) dispatch(statistics(data))
      else dispatch(statistics(data))
      dispatch(fetchInProgress(false))
    } catch (err) {
      console.error('getStats action error:', err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getPatientComplianceExercise(input, customerid) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .getPatientComplianceExercise(input, customerid)
      if (data.error) dispatch(statistics(data))
      else {
        dispatch(fetchInProgress(false))
        return data
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getPatientComplianceMeasurement(input, customerid) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .getPatientComplianceMeasurement(input, customerid)
      if (data.error) dispatch(statistics(data))
      else {
        dispatch(fetchInProgress(false))
        return data
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getPatientComplianceFeedback(input, customerid) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .getPatientComplianceFeedback(input, customerid)
      if (data.error) dispatch(statistics(data))
      else {
        dispatch(fetchInProgress(false))
        return data
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getPatientCompliance(input, customerid) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .getPatientCompliance(input, customerid)
      if (data.error) dispatch(statistics(data))
      else {
        dispatch(fetchInProgress(false))
        return data
      }
    } catch (err) {
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getPatient(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getPatient(id)
      if (data.error) {
        dispatch(operationInProgress(false))
        message.error(data.message)
        return false
      } else {
        dispatch(setPatient(data))
        dispatch(operationInProgress(false))
        return true
      }
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getActiveAssignedDevices(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getActiveAssignedDevices(id)
      if (data.error) {
        dispatch(operationInProgress(false))
        // message.error(data.message)
        return false
      } else {
        dispatch(setActiveAssignedDevices(data?.assigneddevices))
        return true; 
      }
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getFormData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let oks = await serviceInterface.PatientService().getOksData(id)
      let koosJr = await serviceInterface.PatientService().getKoosJrData(id)
      let hoosJr = await serviceInterface.PatientService().getHoosJrData(id)
      let pain = await serviceInterface.PatientService().getPainData(id)
      let painLevel = await serviceInterface
        .PatientService()
        .getPainLevelData(id)
      let flexion = await serviceInterface.PatientService().getFlexionData(id)
      let extension = await serviceInterface
        .PatientService()
        .getExtensionData(id)
      dispatch(operationInProgress(false))
      return { oks, koosJr, hoosJr, pain, painLevel, flexion, extension }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getTracPatchData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let rom = await serviceInterface.PatientService().getTracPatchROM(id)
      let steps = await serviceInterface.PatientService().getTracPatchSteps(id)
      let temperature = await serviceInterface.PatientService().getTracPatchTemperature(id)
      // Best-effort: a patient with no alerts is the normal case, and a
      // failure here must not cost the caller their ROM/steps/temperature.
      let batteryAlerts = null
      try {
        batteryAlerts = await serviceInterface.PatientService().getTracpatchBatteryAlerts(id)
      } catch (e) {
        console.log('battery alerts fetch failed (charts still render)', e)
      }
      dispatch(operationInProgress(false))
      return {
        rom: rom?.data || [],
        steps: steps?.data || [],
        temperature: temperature?.data || [],
        batteryAlerts: batteryAlerts?.data || [],
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getTracpatchExerciseResults(id, exerciseId, startDate, endDate) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let res = await serviceInterface
        .PatientService()
        .getTracpatchExerciseResults(id, exerciseId, startDate, endDate)
      dispatch(operationInProgress(false))
      return { data: res?.data || [] }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      return { data: [] }
    }
  }
}

export function getOksData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getOksData(id)
      dispatch(operationInProgress(false))
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getKoosJrData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getKoosJrData(id)
      dispatch(operationInProgress(false))
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getHoosJrData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getHoosJrData(id)
      dispatch(operationInProgress(false))
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getPainData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getPainData(id)
      dispatch(operationInProgress(false))
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getFlexionData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getFlexionData(id)
      dispatch(operationInProgress(false))
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getExtensionData(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getExtensionData(id)
      dispatch(operationInProgress(false))
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addEvent(id, event, state) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .addEvent(id, event, state)
      dispatch(operationInProgress(false))
      if (data.error) return message.error(data.message)
      dispatch(setPatient(data))
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function editcaregiver(id, input, state) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .editcaregiver(id, input, state)
      dispatch(operationInProgress(false))
      if (data.error) return message.error(data.message)
      dispatch(setPatient(data))
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function edithealthcoach(patientid, healthcoachid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .edithealthcoach(patientid, healthcoachid)
      dispatch(operationInProgress(false))
      if (data.error) return message.error(data.message)
      if (data.status == 'success') return message.success(data.message)
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function editShipAddress(id, address, state) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .editShipAddress(id, address, state)
      dispatch(operationInProgress(false))
      if (data.error) return message.error(data.message)
      dispatch(setPatient(data))
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getForm(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getForm(id)
      dispatch(operationInProgress(false))
      if (data.error) return false
      return data
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addpatient(patient) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().addPatient(patient)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else return true
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addCustomPatient({ patient, devices, exercises, feedback }) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .addCustomPatient({ patient, devices, exercises, feedback })
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else return true
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function addRegisterPatient(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .addRegisterPatient(input)
      dispatch(operationInProgress(false))
      if (data.error) return { status: false, message: data.message }
      else return { status: true }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getConsentForm(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getConsentForm(input)
      if (!data.forms) message.error(data.message)
      else return data.forms
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function validatePatient(patient) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .validatePatient(patient)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else return true
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function editPatient(patient, id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .editPatient(patient, id)
      if (data.status == constants.MESSAGE.SUCCESS)
        message.success(data.message)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else return true
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getLast7Activities(customerid, range) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .getLast7Activities(customerid, range)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        dispatch(lastActivities(data))
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getLast7Measurements(customerid, range) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .PatientService()
        .getLast7Measurements(customerid, range)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        dispatch(lastMeasurements(data))
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getPatientNots(id) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getNotification(id)
      dispatch(operationInProgress(false))
      if (data.error) {
        // message.error(data.message);
        dispatch(setPatNotifications([]))
        return data
      } else {
        dispatch(setPatNotifications(data.notifications))
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
export function getActivityLog(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.PatientService().getActivityLog(input)
      dispatch(operationInProgress(false))
      if (data.error) {
        // message.error(data.message);
        dispatch(setPatActivityLog([]))
        return data
      } else {
        dispatch(setPatActivityLog(data.activitylogs))
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function setPatientPassword(patientid, phone) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .resetPatientPassword({ patientid, phone })
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log('setPatientPassword', err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function sendPatientAuthLink(params) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .sendPatientAuthLink(params)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      console.log('setPatientPassword', err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function sendMobileAppLink(params) {
  return async (dispatch) => {
    try {
      // dispatch(operationInProgress(true));
      var data = await serviceInterface.AuthService().sendMobileAppLink(params)
      // dispatch(operationInProgress(false));
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      console.log('sendMobileAppLink', err)
      // dispatch(operationInProgress(false));
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function deleteAccountRequest(params) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .deleteAccountRequest(params)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function togglePatientStatus(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .togglePatientStatus(input)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log('operationInProgress', err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function resetLoginFailedCount(patientId) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      var data = await serviceInterface
        .AuthService()
        .resetLoginFailedCount(patientId)
      dispatch(operationInProgress(false))
      if (data.error) {
        message.error(data.message)
        return false
      } else {
        message.success(data.message)
        return data
      }
    } catch (err) {
      console.log('operationInProgress', err)
      dispatch(operationInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getPatientDiagnoses(patientId) {
  return async (dispatch) => {
    try {
      dispatch({
        type: ActionType.GET_PATIENT_DIAGNOSES_START,
      })
      let data = await serviceInterface.PatientService().getPatientDiagnoses(patientId)
      if (data.error) {
        dispatch({
          type: ActionType.GET_PATIENT_DIAGNOSES_FAILURE,
          payload: data.message,
        })
        return false
      } else {
        dispatch({
          type: ActionType.GET_PATIENT_DIAGNOSES_SUCCESS,
          payload: data,
        })
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: ActionType.GET_PATIENT_DIAGNOSES_FAILURE,
        payload: 'error communicating with the server',
      })
    }
  }
}

export function getBillingData(patientId, month, year) {
  return async (dispatch) => {
    try {
      dispatch({
        type: ActionType.GET_BILLING_DATA_START,
      })
      let data = await serviceInterface.BillingService().getBillingData(patientId, month, year)
      if (data.error) {
        dispatch({
          type: ActionType.GET_BILLING_DATA_FAILURE,
          payload: data.message,
        })
        return false
      } else {
        dispatch({
          type: ActionType.GET_BILLING_DATA_SUCCESS,
          payload: data,
        })
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: ActionType.GET_BILLING_DATA_FAILURE,
        payload: 'error communicating with the server',
      })
    }
  }
}
